import { Tabs as TabsPrimitive } from "@base-ui/react";
import { twMerge } from "tailwind-merge";
import type { ComponentProps } from "react";

export const TabsRoot = TabsPrimitive.Root;

export interface TabsListProps extends ComponentProps<"div"> {
  /** Classes for the horizontal scroll wrapper around the list. */
  containerClassName?: string;
}

export function TabsList({
  className,
  containerClassName,
  ...props
}: TabsListProps) {
  return (
    <div
      data-slot="tabs-list-scroll"
      className={twMerge(
        "max-w-full overflow-x-auto overscroll-x-contain scrollbar-none",
        containerClassName,
      )}
    >
      <TabsPrimitive.List
        data-slot="tabs-list"
        className={twMerge(
          "inline-flex h-9 w-max items-center justify-start rounded-lg bg-muted p-1 text-muted-foreground",
          className,
        )}
        {...props}
      />
    </div>
  );
}

export interface TabsTabProps extends ComponentProps<"button"> {
  value: string;
}

export function TabsTab({ className, value, ...props }: TabsTabProps) {
  return (
    <TabsPrimitive.Tab
      value={value}
      data-slot="tabs-tab"
      className={twMerge(
        "inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium",
        "transition-all cursor-pointer",
        "hover:text-foreground-subtle",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        "data-disabled:pointer-events-none data-disabled:opacity-50",
        "data-active:bg-background data-active:text-foreground data-active:shadow-sm",
        className,
      )}
      {...props}
    />
  );
}

export interface TabsPanelProps extends ComponentProps<"div"> {
  value: string;
}

export function TabsPanel({ className, value, ...props }: TabsPanelProps) {
  return (
    <TabsPrimitive.Panel
      value={value}
      data-slot="tabs-panel"
      className={twMerge(
        "mt-2",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        className,
      )}
      {...props}
    />
  );
}
